// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a68f9876","501":"deeb56cc"}[chunkId] + ".chunk.js";
};